export * from 'app/zdslogic-ui-shell/@fuse/components/loading-bar/loading-bar.component';
export * from 'app/zdslogic-ui-shell/@fuse/components/loading-bar/loading-bar.module';
